<template>
    <m-layout>
      <div fill-height class="fill-height" style="max-width:100%; position:relative">
        <v-card-title class="m-page__title">
          <span class="headline">Destinations</span>
          <v-btn icon class="mx-0" @click="onRefresh">
             <v-icon color="primary">refresh</v-icon>
          </v-btn>
        </v-card-title>

        <m-destination-form :form="formDestination" :destination="selectedItem" :dialog="dialog_destination" @save="saveDestination" @close="closeDestination"></m-destination-form>
        <m-destination-edit-form :form="formDestination" :destination="selectedItem" :dialog="dialog_destination_edit" @update="updateDestination" @close="closeDestination"></m-destination-edit-form>

        <v-card style="max-width:100%; position:relative">
          <v-card-title>
            <v-btn
              absolute
              dark
              fab
              top
              right
              color="primary"
              @click.native.stop="dialog_destination = true">
              <v-icon>add</v-icon>
            </v-btn>

            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table
              v-bind:headers="headers"
              v-bind:items="items"
              v-bind:search="search"
              :sort-by="['id']"
              :sort-desc="[true]"
              :footer-props="{
                'items-per-page-options': [30, 40, {text:'All', value:-1}]
              }"
              dense
            >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id" :class="{'error-item' :  inValidItem(item)}">

              <td >{{ item.id }}</td>
              <td >{{ item.name }}</td>
              <td >{{ item.address }}</td>
              <td >{{ item.zip }}</td>
              <td >{{ item.city }}</td>
              <td>
                <div style="display: flex">
                <v-btn icon class="mx-0" @click="editItem(item)">
                  <v-icon color="primary">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0" @click="deleteItem(item)">
                  <v-icon color="primary">delete</v-icon>
                </v-btn>
                </div>
              </td>
              </tr>
              </tbody>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
        </v-card>


      </div>
    </m-layout>
</template>

<script>
  import DestinationForm from '@/components/destination/form.vue'
  import DestinationEditForm from '@/components/destination/edit.vue'

  export default {
    components: {
      'm-destination-form': DestinationForm,
      'm-destination-edit-form': DestinationEditForm
    },
    data () {
      return {
        formDestination: {},
        menu: false,
        menu2: false,
        time: null,
        date: null,
        dateFormatted: null,
        dialog_destination: false,
        dialog_destination_edit: false,
        search: '',
        options: {},
        selectedItem: {},
        headers: [
          {
            text: 'ID',
            align: 'left',
            value: 'id'
          },
          { text: 'Name', value: 'name' },
          { text: 'Address', value: 'address' },
          { text: 'Zip', value: 'zip' },
          { text: 'City', value: 'city' },
          { text: 'Action', value: 'action' }
        ],
        items: []
      }
    },
    methods: {
      formatDate (date) {
        if (!date) {
          return null
        }
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      closeDestination () {
        this.dialog_destination = false;
        this.dialog_destination_edit = false;
        this.resetDestination();
        console.log('close');
      },
      resetDestination () {
        this.formDestination = {};
      },
      onRefresh () {
        this.getDataDestination();
      },
      inValidItem (item) {
        return !item.fullAddress;
      },
      saveDestination (data) {
        // var app = this;
        this.$http
        .post('api/destination', data)
        .then(response => {
          console.log('response data', response.data);
          // app.items = response.data;
          this.closeDestination();
          this.getDataDestination();
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      updateDestination (data) {
        // var app = this;
        var id = this.selectedItem.id;
        console.log('updateForm', data);
        this.$http
        .put('api/destination/' + id, data)
        .then(response => {
          console.log('response data', response.data);
          this.getDataDestination();
          this.closeDestination();
          // app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      editItem (item) {
        this.resetDestination();
        this.selectedItem = this.items.find(i => i === item);
        this.dialog_destination_edit = true;
        console.log('edit', this.selectedItem.id);
      },
      deleteItem (item) {
        this.$http
        .delete('api/destination/' + item.id)
        .then(response => {
          console.log('user deleted', response.data);
          this.getDataDestination();
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      getDataDestination () {
        var app = this;
        this.$http
        .get('api/destination')
        .then(response => {
          console.log('data', response.data);
          app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      getDataById (id) {
        var app = this;
        return new Promise((resolve, reject) => {
          this.$http
          .get('api/destination/' + id)
          .then(response => {
            console.log('destination getDataById:', response.data);
            app.items = response.data;
            resolve(app.items);
          })
          .catch(function (error) {
            reject(error);
          });
        });
      },
      isDirectLink (item) {
        item = item || this.$route.params.item || {}
        if (item.id && item.route === this.$route.name) {
          this.getDataById(item.id).then((items) => {
            this.editItem(items[0]);
          });
          this.$route.params.item = null;
        }
      }
    },
    created () {
      this.getDataDestination();
      this.$bus.$on('search:show', this.isDirectLink);
    },
    mounted () {
      this.isDirectLink();
    },
    beforeDestroy () {
      this.$bus.$off('search:show', this.isDirectLink);
    }
  }
</script>

<style lang="scss">
.error {
  text-transform: none;
  color: grey;

  &-item {
    color:rgba(248, 1, 1, 1) !important;
  }
}
</style>









